module.exports = __webpack_public_path__ + "img/icon-collapse.2a83f00e.svg";